/* eslint-disable */


import * as Dialog from '@radix-ui/react-dialog';
// import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import React from 'react';
import { PackagesResponse } from '../../artist/Dashboard/Images/ImageDetails';
import useSWR from 'swr';
import api from '../../../utils/api';
import CoinIcon from '../../../assets/coinsvg.png'
import CloseBtnSvg from '../../../assets/CloseButtonsvg.svg'

type PurchaseCreditsModelProps = {
  trigger: React.ReactNode;
  isOpen?: boolean;
  setIsOpen?: (open: boolean) => void;
};

const PurchaseCreditsModel: React.FC<PurchaseCreditsModelProps> = ({ trigger, isOpen, setIsOpen }) => {
  const { data: OneTimeplans } = useSWR<PackagesResponse>('/subscriptions/v1/credits/packages', api);

  const handlePurchaseClick = async ({ priceId }: { priceId: string }) => {
    try {
      const { data } = await api.post('/subscriptions/v1/credits/me/purchase', {
        mode: 'payment',
        priceId: priceId,
        successUrl: window.location.href,
        cancelUrl: '/account?plan=true#billing'
      });
      window.location.href = data;
    } catch (error) {
      console.error('Error while purchasing credits', error);
    }
  };

  return (
    
    <Dialog.Root open={isOpen} onOpenChange={(open) => setIsOpen?.(open)} >
      <Dialog.Trigger asChild>{trigger}</Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-[#1b1d1eb3] data-[state=open]:animate-overlayShow transition-opacity duration-300 font-inter"/>
        <Dialog.Content className="data-[state=open]:animate-contentShow fixed z-[9999] top-[50%] left-[50%] right-[50%] overflow-hidden lg:h-auto lg:max-w-[1120px] translate-x-[-50%] translate-y-[-50%] rounded-[10px] bg-black shadow-xl focus:outline-none top-[55%] lg:top-[50%] w-[90%] lg:w-[95%] p-4 lg:p-6 lg:h-auto">
          <Dialog.Title className="m-0 flex justify-between items-center">
            <p className="font-[700] text-white text-[18px] md:text-[20px] font-inter">Buy Extra Credits</p>
          </Dialog.Title>

          <Dialog.Close asChild>
            <button className="absolute top-4 right-5 text-xs bg-transparent text-white hover:text-gray-400 inline-flex h-[35px] items-center justify-center rounded-full  transition-all duration-200">
              <img src={CloseBtnSvg} alt="Coin Icon" className="w-[23.33px] h-[23.33px]" />
            </button>
          </Dialog.Close>

          <Dialog.Description className="text-xs mt-1 mb-6 text-[15px] leading-normal text-[#909090]]">
            <p className="font-[400] text-[#A8A8A8] font-inter text-[16px] md:text-[20px]">Choose a plan to add credits on top of your current plan balance.</p>
          </Dialog.Description>

          <div className="flex flex-col lg:flex-row gap-4 lg:gap-6 overflow-y-auto lg:overflow-x-auto lg:overflow-y-visible pb-4 w-full max-h-[60vh] lg:max-h-none items-center lg:items-start">

            {OneTimeplans?.data?.sort((a, b) => parseFloat(a.price) - parseFloat(b.price)).map((plan, i) => (
              <div
                key={i}
                className="w-full max-w-none sm:max-w-[250px] min-h-auto bg-[#18181B] rounded-lg flex flex-col items-start p-4 md:p-6 sm:w-[48%] md:w-[48%] lg:w-[250px] transition-transform duration-200 hover:scale-105"
              >
                <img src={CoinIcon} alt="Coin Icon"  />
                <div className="w-full my-4">
                  {/* Title */}
                  <p className="text-white font-[300] text-[18px] md:text-[20px] font-inter">Credits</p>
                  {/* Credits and price side-by-side */}
                  <div className="flex justify-between items-center w-full font-inter">
                    <p className="text-white font-[700] text-[22px] md:text-[26px]">{plan.credits}</p>
                    <p className="text-white font-[600] text-[18px] md:text-[20px]">${plan.price}</p>
                  </div>
                </div>
                <button onClick={() => handlePurchaseClick({ priceId: plan.priceId })} 
                className="w-full h-8 md:h-10 text-xs md:text-sm text-white rounded-full font-medium font-inter"
                  style={{
                        background: 'linear-gradient(139.56deg, #0CAECF -29.1%, #580F6B 96.45%)'
                  }}>
                  Select
                </button>
              </div>
            ))}
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>


  );
};

export default PurchaseCreditsModel;
